import React from "react";
import { List } from "@mui/material";
import ProcessItem from "./ProcessItem";

const ProcessList = ({
  processos, 
  selectedProcessos = new Set(), 
  pendingSelections = new Set(), 
  confirmedSelections = new Set(), 
  onSelectProcesso = () => {}, 
  updatingItems = new Set(),
  showSelectionControls = false
}) => {
  return (
    <List disablePadding>
      {processos?.map((process, index) => (
        <ProcessItem 
          processo={process} 
          key={index}
          isSelected={selectedProcessos.has(process.id)}
          isPending={pendingSelections.has(process.id)}
          isConfirmed={confirmedSelections.has(process.id)}
          onSelect={() => onSelectProcesso(process.id)}
          isUpdating={updatingItems.has(process.id)}
          showSelectionControls={showSelectionControls}
        />
      ))}
    </List>
  );
};

export default ProcessList;
